const $ = require('jquery');

$(function () {
    'use strict';

    const $formErrors = $('.errorlist').first();
    const errorEl = $formErrors.get(0);

    if (errorEl) {
        errorEl.scrollIntoView({
            block: 'center',
            behavior: "smooth"
        });
    }
});
